import DataGridTable from './dataGridTable'
export default DataGridTable
